export enum CalloutPlacement {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'start',
  RIGHT = 'end',
}
